import styled from 'styled-components/native'

import Button from 'APP/Converse/Button'
import { ResponsiveFlatList } from 'APP/Converse/Layout'
import Typography from 'APP/Converse/Typography'

type ConversationContainerProps = {
  inputBarHeight: number
}

export const ConversationContainer = styled.View<ConversationContainerProps>`
  flex: 1;
  padding-bottom: ${(props) => props.inputBarHeight}px;
`

export const ScrollViewContainer = styled(ResponsiveFlatList)`
  flex: 1;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  position: relative;
`

export const InputBarContainer = styled.View`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.theme.colors.background};
  display: flex;
  align-items: center;
`

export const UnreadMessagesContainer = styled.View`
  position: absolute;
  align-self: center;
  bottom: ${(props) => props.theme.metrics.baseMargin * 5}px;
  ${(props) => props.theme.shadows.normal}
`

export const UnreadMessagesButton = styled(Button)`
  margin: ${(props) => props.theme.metrics.baseMargin}px;
`

export const TopBannersContainer = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

export const LoadingContainer = styled.View`
  display: flex;
  position: absolute;
  margin: ${(props) => props.theme.metrics.baseMargin}px;
  padding: ${(props) => props.theme.metrics.baseMargin / 2}px;
  flex-direction: row;
  align-self: center;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 100px;
  ${(props) => props.theme.shadows.normal}
`

export const LoadingText = styled(Typography)`
  padding-horizontal: ${(props) => props.theme.metrics.baseMargin / 2}px;
  color: ${(props) => props.theme.colors.text};
`
